<template>
  <div class="form">
    <div class="inputRow" v-for="field in fields" v-bind:key="field.name">
      <div v-if="field.type === 'string'">
        <label class="inputLabel">{{field.label || field.name}}</label>
        <input
          class="input"
          v-model="user[field.name]"
        />
      </div>
      <div class="lineBreak" v-if="field.type === 'lineBreak'"></div>
    </div>
    <div class="actionRow">
      <button class="action" v-on:click="save">Save</button>
    </div>
  </div>
</template>

<script>
import { Auth } from '@aws-amplify/auth'
import AmplifyStore from '../store/store'

export default {
  name: 'ProfileForm',
  props: ['fields'],
  data: function () {
    return {
      user: {}
    }
  },
  mounted: function () {
    var self = this
    if (AmplifyStore.state.user) {
      Auth.currentUserInfo().then(function (currentUser) {
        self.user = Object.assign(
          { username: currentUser.username },
          currentUser.attributes
        )
      })
    }
  },
  methods: {
    save: function () {
      var self = this
      var cognitoUser = AmplifyStore.state.user
      if (!self.user || !cognitoUser) { return }
      Auth.updateUserAttributes(cognitoUser, self.user)
        .then(function (res) {
          console.log(res)
        })
        .catch(function (e) {
          console.log(e)
        })
    }
  }
}
</script>
